import type { SavedCreation, SerializedNote } from './types';

const STORAGE_KEY = 'hum-canvas-archive';
const MAX_SAVES = 50;

export function getSavedCreations(): SavedCreation[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch { /* ignore */ }
  return [];
}

export function saveCreation(
  name: string,
  notes: SerializedNote[],
  thumbnail: string,
  duration: number,
): SavedCreation | null {
  const creations = getSavedCreations();
  if (creations.length >= MAX_SAVES) {
    creations.shift();
  }
  const creation: SavedCreation = {
    id: `hc_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
    name,
    notes,
    thumbnail,
    createdAt: Date.now(),
    duration,
  };
  creations.push(creation);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(creations));
  } catch { /* quota exceeded */ return null; }
  return creation;
}

export function deleteCreation(id: string): boolean {
  const creations = getSavedCreations();
  const idx = creations.findIndex(c => c.id === id);
  if (idx === -1) return false;
  creations.splice(idx, 1);
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(creations)); } catch { /* quota */ }
  return true;
}

export function renameCreation(id: string, newName: string): boolean {
  const creations = getSavedCreations();
  const c = creations.find(c => c.id === id);
  if (!c) return false;
  c.name = newName;
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(creations)); } catch { /* quota */ }
  return true;
}
